import type { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { agentsRoute } from '@townsquare/routes/agents';
import { rovoEntitlementResource } from '@townsquare/rovo/entitlement';

import { AgentsViewLoadable, BrowseAgentsViewLoadable } from './components/AgentsView';
import { browseAgentResource } from './resources/BrowseAgentResource';

agentsRoute.component = AgentsViewLoadable;
agentsRoute.resources = [rovoEntitlementResource];
agentsRoute.featureGating = {
	gates: ['rovo_agents_studio_browse_kit_home'],
	experiments: [{ key: 'jira_browse_agent_modal_update', isEnabled: true }],
	behavior: {
		type: 'override',
		override: {
			component: BrowseAgentsViewLoadable,
			nav4Layout: 'home',
			resources: [rovoEntitlementResource, browseAgentResource],
		},
	},
};
export const agentsRouterRoute: GlobalHomePageRoute = agentsRoute;
